import { IContainer } from "../../../../../../common/container/IContainer";
import { AdditionalNavItem } from "./AdditionalNavItem/AdditionalNavItem";
import { AdditionalNavItemToken } from "./AdditionalNavItem/AdditionalNavItemToken";

export const leftNavigationContainer = (container: IContainer): IContainer => {
  container.setByToken(AdditionalNavItemToken, AdditionalNavItem);

  return container;
}